module.exports = __webpack_public_path__ + "img/logo_small.68aa35ab.png";